import {useState, useEffect} from 'react';

import { getUserById } from '../services/UserServices';

// Returns [admin, checking]. `checking` is derived during render (not set in an effect),
// so the render right after login already knows the role is still loading.
const useGetUserRole = (userId) => {

    const [role, setRole] = useState({ userId: null, admin: false });

    useEffect(()=>{
        if (!userId) return;
        let cancelled = false;
        getUserById(userId)
        .then((result)=>{
            !cancelled && setRole({ userId, admin: Boolean(result.user?.admin) });
        })
        .catch(()=>!cancelled && setRole({ userId, admin: false }));
        return () => { cancelled = true; };
    },[userId]);

    const known = Boolean(userId) && role.userId === userId;
    return [known && role.admin, Boolean(userId) && !known];
}

export default useGetUserRole;
